const fnPlan = (() => {
  const pageFamilyNature = (document.getElementById("pageFamilyNature") != null);
  if (pageFamilyNature) {


    let sW = window.innerWidth;

    let centeredSlides;
    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      centeredSlides = false
      slidesPerView = 1.0
      spaceBetween = 40
    } else {
      centeredSlides = true
      slidesPerView = 1.3
      spaceBetween = 20
    }

    const swiper = new Swiper("#jsSwiperPlan", {
      loop: true,
      centeredSlides: centeredSlides,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 800,
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });

    let swiperCopy = document.getElementById("jsSwiperPlanCopy")
    let num = swiperCopy.querySelector('.js-num');
    let ttl = swiperCopy.querySelector('.js-ttl');
    let txt = swiperCopy.querySelector('.js-txt');
    swiper.on('slideChange', function () {
      if (swiper.realIndex == 0) {
        num.textContent = `#1`;
        ttl.textContent = `ファミリークローゼット`;
        txt.textContent = `大容量のファミリークローゼットには家族全員の洋服を収納。生活感が出がちな掃除道具を入れたり、日用品のストックや季節物も収まる十分なスペース。片付けが一か所にまとまって家事効率はグンとラクに。`;
      } else if (swiper.realIndex == 1) {
        num.textContent = `#2`;
        ttl.textContent = `子供部屋`;
        txt.textContent = `2段ベッドを置いてスペースに余裕をとり、今は子どもたちの自由なプレイ空間に。長女はダンスの練習をしたり、長男は好きな電車ごっこをしたり。成長に合わせて使い方を変えられる、今後の変化も楽しみな部屋。`;
      } else if (swiper.realIndex == 2) {
        num.textContent = `#3`;
        ttl.textContent = `スタディルーム`;
        txt.textContent = `子どもの習い事や宿題をするスペースとしてはもちろん、リモートワークの日にも大活躍のスタディルーム。程よいこもり感はプライベートとのメリハリに最適。将来は子供達の専用学習スペースとしても活用できるといいな。`;
      } else if (swiper.realIndex == 3) {
        num.textContent = `#4`;
        ttl.textContent = `バルコニー`;
        txt.textContent = `広々バルコニーは、開口を活かしていろんなくつろぎ方ができる、我が家の第2のリビング。毎朝のピラティスが心地よく行えるだけでなく、コーヒーを飲んだり、読書をしたり、それぞれに楽しむ姿が見られる表情豊かな場所。`;
      }
    });

    let swiperBtn = document.getElementById("jsSwiperPlanBtn")
    let btn = swiperBtn.querySelectorAll('.btn');
    for (let i = 0; i < btn.length; i++){
      btn[i].addEventListener('click', () => {
        if(i == 0){
          swiper.slideToLoop(0)
        }
        if(i == 1){
          swiper.slideToLoop(1)
        }
        if(i == 2){
          swiper.slideToLoop(2)
        }
        if(i == 3){
          swiper.slideToLoop(3)
        }
      });
    }


  }
})();
export default fnPlan;